import { Checkbox, FormControlLabel } from "@material-ui/core";
import { memo } from "react";
import { useFluxoDeCaixaService } from "../contexts";

const FinanceCategoryCheckBox = ({ financeCategory, level }) => {
  const { cachedFinanceCategories, setCachedFinanceCategories, filters } =
    useFluxoDeCaixaService();
  const marginLeft = level * 8;

  const hasChildren = (parentId) =>
    cachedFinanceCategories.some((category) => category.parentId === parentId);

  const handleChildrenCheck = ({ parent, child, checked, parents }) => {
    if (parents.includes(child.parentId)) {
      return { ...child, checked };
    }

    const parentsTree = recursiveGetParent(parent, []);

    if (
      child.id === parent.id ||
      (child.id === parent.parentId && !child.checked)
    ) {
      return { ...child, checked };
    }

    if (parentsTree.includes(child.id)) {
      return { ...child, checked: true };
    }

    return child;
  };

  const recursiveGetParent = (child, parents) => {
    const parent = cachedFinanceCategories.find(
      (category) => category.id === child.parentId
    );
    if (parent) {
      parents.push(parent.id);
      recursiveGetParent(parent, parents);
    }

    return parents;
  };

  const handleCheck = (category, checked) => {
    const parents = [category.id];
    cachedFinanceCategories
      .filter((child) => child.parentId === category.id)
      .forEach((child) => {
        const isParent = hasChildren(child.id);
        if (isParent) {
          parents.push(child.id);
        }
      });

    const checkedCategories = cachedFinanceCategories.map((c) =>
      handleChildrenCheck({ checked, parent: category, child: c, parents })
    );

    setCachedFinanceCategories(checkedCategories);
  };

  const children = cachedFinanceCategories
    .filter((category) => category.parentId === financeCategory?.id)
    .map((category) => (
      <FinanceCategoryCheckBox
        financeCategory={category}
        level={level + 3}
        key={category.id}
      />
    ));

  return (
    <>
      <FormControlLabel
        key={financeCategory.id}
        label={financeCategory.desc}
        style={{ marginLeft }}
        control={
          <Checkbox
            disabled={!filters.useFinanceCategories}
            checked={financeCategory.checked}
            onChange={(event) => {
              handleCheck(financeCategory, event.target.checked);
            }}
          />
        }
      />
      {children}
    </>
  );
};

export default memo(FinanceCategoryCheckBox);
